import React from 'react';
import classnames from 'classnames';
import Item from './Item';
import * as styles from './nav.module.scss';

const Nav = ({ data }) => {
  return (
    <nav className={classnames(styles.nav)}>
      <ul className={classnames(styles.list)}>
        {data.map((item) => {
          return (
            <li key={item.text} className={classnames(styles.listItem)}>
              <Item href={item.href} text={item.text} />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
